import borderStyles from './borderStyles';
import borderWidths from './borderWidths';
import colors from './colors';
import fonts from './fonts';
import fontSizes from './fontSizes';
import radii from './radii';
import shadows from './shadows';
import sizes from './sizes';
import space from './space';
import transitions from './transitions';
import zIndices from './zIndices';

export default {
  borderStyles,
  borderWidths,
  colors,
  fonts,
  fontSizes,
  radii,
  shadows,
  sizes,
  space,
  transitions,
  zIndices,
};
